import { ColDef, ICellRendererParams, GridOptions } from "ag-grid-community";
import { useEffect, useState, useRef } from "react";
import AgGridTable from "../../../components/table/AgGridTable";
import eventEmitter from "../../../components/utils/eventEmitter";
import {
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  Tooltip,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Popover,
  Button,
  Skeleton,
  LinearProgress,
  Divider,
  Menu,
  MenuItem,
  Chip,
  Drawer,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DownloadIcon from "@mui/icons-material/Download";
import axiosInstance from "../../../axios/axios";
import { useTheme } from "@mui/material/styles";
import NoData_img1 from "../../../../src/assets/baseVersion/NoData_Search_img.svg";
import moment from "moment";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import * as echarts from "echarts";
import CVEDetailsDrawer from "../../../components/cve/CVEDetailsDrawer";
import AssetDetailsDrawer from "../../../components/asset/AssetDetailsDrawer";
import cveBug from "../../../assets/cve-bug.svg";
import { useNavigate, useLocation } from "react-router-dom";
import useRolePermissions from "../../../shared/hooks/useRolePermissions";
import useFrameworks from "../../../shared/hooks/useFrameworks";
import { ROLES_ROUTE } from "../../../shared/constants/constant-data";
import cveBugError from "../../../assets/cve-bug-error.svg";
import ciscoLogo from "../../../assets/cisco-assets.svg";
import paloaltoLogo from "../../../assets/paloalto-assets.svg";
import aristaLogo from "../../../assets/arista-assets.svg";
import paloalto_dark from "../../../assets/paloalto-white.svg";
import cisco_dark from "../../../assets/cisco-white.svg";
import arista_dark from "../../../assets/arista-white.svg";
import juniperLogo from "../../../assets/juniper.svg";
import juniper_dark from "../../../assets/juniper-white.svg";
import debian from "../../../assets/debian.svg";
import debian_dark from "../../../assets/debian_dark.svg";
import fortinetLogo from "../../../assets/fortinet.svg";
import fortinet_dark from "../../../assets/fortinet-white-1.svg";
import ubuntu_light from "../../../assets/ubuntu_white.svg";
import ubuntu_dark from "../../../assets/ubuntu_dark.svg";
import sophosLogo from "../../../assets/sophos.svg";
import sophos_dark from "../../../assets/sophos-white.svg";
import windows_light from "../../../assets/baseVersion/Windows_light.svg";
import windows_dark from "../../../assets/baseVersion/Windows_dark.svg";
import redhat_light from "../../../assets/redhat_light.svg";
import redhat_dark from "../../../assets/redhat_dark.svg";
import huawei_light from "../../../assets/huawei-ar21 1.svg";
import mikrotik from "../../../assets/mikrotik.svg";
import mikrotik_dark from "../../../assets/mikrotik_dark.svg";
import huawei_dark from "../../../assets/huawei-dark.svg";
import edgecore_logo from "../../../assets/baseVersion/edgecore-logo.svg";
import tplink_light from "../../../assets/baseVersion/TPLINK_Logo_2 1.svg";
import tplink_dark from "../../../assets/baseVersion/TPLINK_Logo_dark.svg";
import dell_logo from "../../../assets/baseVersion/dell-seeklogo 2.svg";
import syrotech_light from "../../../assets/syrotech_light.svg";
import syrotech_dark from "../../../assets/syrotech_dark.svg";
import CVETimelineView from "../../../components/cve/CVETimelineView";
import { useStorageManager } from "../../../shared/hooks";
import { END_POINTS } from "../../../shared";
import { toast } from "react-toastify";
// import SecurityIcon from '@mui/icons-material/Security';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import React from "react";
import { authActions } from "../../../store/authSlice";
import { useDispatch } from "react-redux";
import AssetComplianceReportDrawer from "../../../components/asset/AssetComplianceReportDrawer";
import { setConfigDiffData } from "../ConfigDiff/ConfigDiff-slice";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export interface CVEData {
  cve_id: string;
  asset_count: number;
  description: string;
  cisas_kev: string;
  epss: string;
  version: string;
  score: string;
  vector_string: string;
  severity: string;
  cvss_data: Array<{
    score: number;
    vector_string: string;
    severity: string;
    version: string;
  }>;
  cve_issued_date: string;
  cve_last_updated: string;
  summaryData?: {
    cve_summary: string;
    cve_details: {
      vulnerability_name: string | null;
      date_added: string | null;
      due_date: string | null;
      required_action: string | null;
    };
    nvd_pd: string;
    nvd_lmd: string;
    source: string;
    severity: string;
    vulnerability_details: {
      authority: string[];
      attack_vector: string;
      confedentiality_impact: string;
      attack_complexity: string;
      integrity_impact: string;
      privileges_required: string;
      availability_impact: string;
      user_interaction: string;
      scope: string;
      cvss_score: number;
      cisco_data_flag: boolean;
      cisco_data: {
        attack_vector: string;
        confedentiality_impact: string;
        attack_complexity: string;
        integrity_impact: string;
        privileges_required: string;
        availability_impact: string;
        user_interaction: string;
        scope: string;
        cvss_score: number;
        severity: string;
      };
      epss_details: {
        pea: number;
        pov: number;
      };
    };
    reference: Array<{
      hyperlinks: {
        label: string;
        link: string;
        resources: string;
      };
    }>;
    weakness_enumeration: Array<{
      cwe_id: string;
      cwe_name: string;
      source: string;
    }>;
    known_affected_sc: Array<{
      cpe: string;
      to?: string;
      to_include?: boolean;
    }>;
    cisa_data_available: boolean;
    epss_data_available: boolean;
  };
}

interface VulnerabilityLevels {
  critical: number;
  high: number;
  medium: number;
  low: number;
}

interface AssetData {
  id: string;
  device_id: string;
  vendor: string;
  device_type: string;
  total: string;
  last_scan: string;
  vulnerability_levels: VulnerabilityLevels[];
  device_name: string;
  region_id: number;
  region_name: string;
  schedule: string;
  rescan: boolean;
  status: number;
  security_score: number;
  vulnerability: number;
  cve: number;
  cve_last_modified: string;
}

interface APIResponse {
  status: number;
  message: string;
  data: {
    num_of_pages: number;
    cve_list: CVEData[];
  };
}

interface AssetAPIResponse {
  status: number;
  message: string;
  data: {
    device_list: AssetData[];
  };
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`cve-tabpanel-${index}`}
      aria-labelledby={`cve-tab-${index}`}
      style={{ height: "100%" }}
      {...other}
    >
      {value === index && <Box sx={{ height: "100%" }}>{children}</Box>}
    </div>
  );
}

const CVEScreen = () => {
  const theme = useTheme();
  const location = useLocation();
  const { hasPermissions } = useRolePermissions();
  const { isFrameworkKeyOn } = useFrameworks();
  const [cveData, setCveData] = useState<CVEData[]>([]);
  const [assetData, setAssetData] = useState<AssetData[]>([]);
  const [loading, setLoading] = useState(false);
  const [isSummaryLoading, setIsSummaryLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const prevTabValueRef = useRef<number>(-1);
  const [summaryExpanded, setSummaryExpanded] = useState(true);
  const [selectedCVE, setSelectedCVE] = useState<CVEData | null>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dashboardScore, setDashboardScore] = useState<number>(0);
  const [selectedOption, setSelectedOption] = useState("CVE");
  const [downloading, setDownloading] = useState(false);
  const [selectedDrawerTab, setSelectedDrawerTab] = useState(0);

  const [vulnerabilityCounts, setVulnerabilityCounts] =
    useState<VulnerabilityLevels>({
      critical: 0,
      high: 0,
      medium: 0,
      low: 0,
    });
  const [isAllZero, setIsAllZero] = useState<boolean>(false);
  const [selectedAsset, setSelectedAsset] = useState<AssetData | null>(null);
  const [assetDrawerOpen, setAssetDrawerOpen] = useState(false);
  const isDarkMode = theme.palette.mode === "dark";
  const [isDrawerLoading, setIsDrawerLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(menuAnchorEl);
  const dispatch = useDispatch();

  const handleMenuKebabClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };
  const [trigger, setTrigger] = useState(0); // Used to re-trigger the effect
  const [isReportDialogOpen, setIsReportDialogOpen] = useState(false);
  const [reportFormat, setReportFormat] = useState("excel");

  const handleMenuKebabClose = () => {
    setMenuAnchorEl(null);
  };

  const handleDialogClose = () => {
    setIsReportDialogOpen(false);
  };

  const getUserTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  };

  const handleDownloadReport = async () => {
    setDownloading(true);
    console.log(`Downloading CVE report in ${reportFormat} format`);
    setIsReportDialogOpen(false);
    const timeZone = getUserTimezone();
    const payload = {
      report_format: reportFormat,

      time_zone: timeZone,
      type: "org_cve",
      module: "on_premise",
      asset_ids:"1",
    };
    try {
      const response = await axiosInstance.post(
        END_POINTS.REPORT_DOWNLOAD,
        payload
      );
      if (response.status === 200) {
        toast.success("Report request submitted, please check Reports section.");
      } else {
        toast.error("Failed to download the report.");
      }
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Something went wrong"
      );

    } finally {
      setDownloading(false); // ✅ always runs
    }
  };

  const [reportDrawerOpen, setReportDrawerOpen] = useState(false);

  const handleAssetComplianceReport = () => {
    setAssetDrawerOpen(false);
    setReportDrawerOpen(true);
  };

  // Chart refs
  const scoreChartRef = useRef<HTMLDivElement>(null);
  const vulnerabilityChartRef = useRef<HTMLDivElement>(null);

  const [popoverAnchor, setPopoverAnchor] = useState<{
    mouseX: number;
    mouseY: number;
  } | null>(null);
  const [popoverContent, setPopoverContent] = useState<{
    vector: string;
    metrics?: Array<{ name: string; value: string }>;
    topic?: string;
  } | null>(null);

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement>,
    vector: string,
    metrics?: Array<{ name: string; value: string }>,
    topic?: string
  ) => {
    event.preventDefault();
    event.stopPropagation();
    setPopoverAnchor({
      mouseX: event.clientX,
      mouseY: event.clientY,
    });
    setPopoverContent({
      vector,
      metrics,
      topic,
    });
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleVulnerabilityClick = async () => {
    try {
      const response = await axiosInstance.get(
        "/securityscan/cve_vulnerability"
      );
      console.log("ResponsehandleVulnerabilityClick", response);
      if (response?.data.status === 200) {
        const vulnerabilityData = response?.data.data;
        console.log("Vulnerability Data:", vulnerabilityData);
        setVulnerabilityCounts({
          critical: vulnerabilityData.critical,
          high: vulnerabilityData.high,
          medium: vulnerabilityData.medium,
          low: vulnerabilityData.low,
        });
        if (
          vulnerabilityData.critical === 0 &&
          vulnerabilityData.high === 0 &&
          vulnerabilityData.medium === 0 &&
          vulnerabilityData.low === 0
        ) {
          setIsAllZero(true);
        } else {
          setIsAllZero(false);
        }
      }
    } catch (error) {
      console.error("Error fetching vulnerability data:", error);
    } finally {
      setAnchorEl(null);
    }
  };

  const handleSelecVulnerability = () => {
    setSelectedOption("Vulnerabilities");
    setAnchorEl(null);

    handleVulnerabilityClick();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePopoverClose = () => {
    setPopoverAnchor(null);
    setPopoverContent(null);
  };

  const isPopoverOpen = Boolean(popoverAnchor);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleSummaryChange = () => {
    setSummaryExpanded(!summaryExpanded);
  };

  const fetchCVEData = async () => {
    try {
      setIsLoading(true);
      const payload: any = { type: 1 };
      if (location.state && (location.state as any).id) {
        payload.cve_id = (location.state as any).id;
      }
      const response = await axiosInstance.post<APIResponse>(
        "securityscan/cve/search_cve",
        payload
      );
      if (response.data.status === 200) {
        setCveData(response.data.data.cve_list);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching CVE data:", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  //  const fetchUniqueCVE = async () => {
  //   try {
  //     setIsLoading(true);
  //     const response = await axiosInstance.get(
  //       "/securityscan/dashboard-cve-vulnerabilities",
  //     );
  //     if (response.data.status === 200) {
  //       // setCveData(response.data.data.cve_list);
  //       // setIsLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching CVE data:", error);
  //     setIsLoading(false);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // useEffect(()=>{
  //   fetchUniqueCVE();
  // },[fetchUniqueCVE])

  const handleCVEClick = async (cveData: CVEData, tabIndex: number = 0) => {
    console.log("CVE Data Clicked:", cveData);
    setSelectedCVE(cveData);
    setSelectedDrawerTab(tabIndex);
    setDrawerOpen(true);
    setIsDrawerLoading(true);

    try {
      const payload = { cve: cveData.cve_id };
      const response = await axiosInstance.post(
        "securityscan/cve/cve_summary",
        payload
      );

      if (response.data.status === 200) {
        setSelectedCVE({
          ...cveData,
          summaryData: response.data.data.cve_summary_details,
        });
      }
    } catch (error) {
      console.error("Error fetching CVE summary:", error);
    } finally {
      setIsDrawerLoading(false);
    }
  };

  const fetchAssetData = async () => {
    try {
      setIsLoading(true);
      const payload = { type: 1 };
      const response = await axiosInstance.post<AssetAPIResponse>(
        "securityscan/on-prem/asset-list",
        payload
      );

      if (response.data.status === 200) {
        setAssetData(response.data.data.device_list);
        dispatch(
          authActions.login({
            assetsData: response.data.data.device_list,
          })
        );
        setIsLoading(false);
      }
    } catch (error) {
      // Using a type assertion for the error object
      const err = error as {
        message: string;
        response?: { data: any; status: number };
      };
      console.error("Error fetching asset data:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
      });
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  const fetchDashboardScore = async () => {
    try {
      const response = await axiosInstance.get("securityscan/dashboard-score");
      if (response.data.status === 200 && response.data.data) {
        const score = response.data.data.cve_score || 0;
        setDashboardScore(Math.round(score));

        // Determine the color based on the score
        let chartColor = "#22C55E"; // Green for >70
        if (score < 50) {
          chartColor = "#DC2626"; // Red for <50
        } else if (score >= 50 && score <= 70) {
          chartColor = "#F97316"; // Orange for 50-70
        }

        // Update the score chart
        const scoreChart =
          scoreChartRef.current &&
          echarts.getInstanceByDom(scoreChartRef.current);
        if (scoreChart) {
          const scoreOption = {
            series: [
              {
                type: "gauge",
                startAngle: 90,
                endAngle: -270,
                pointer: { show: false },
                progress: {
                  show: true,
                  overlap: false,
                  roundCap: true,
                  clip: false,
                  itemStyle: {
                    color: chartColor, // Use the dynamic color
                  },
                },
                axisLine: {
                  lineStyle: {
                    width: 10,
                    color: [[1, "#E5E7EB"]],
                  },
                },
                splitLine: { show: false },
                axisTick: { show: false },
                axisLabel: { show: false },
                data: [{ value: score }],
                detail: { show: false },
              },
            ],
          };
          scoreChart.setOption(scoreOption);
        }
      } else {
        setDashboardScore(0);
        // Handle the case where the score is 0
        const scoreChart =
          scoreChartRef.current &&
          echarts.getInstanceByDom(scoreChartRef.current);
        if (scoreChart) {
          const scoreOption = {
            series: [
              {
                type: "gauge",
                startAngle: 90,
                endAngle: -270,
                pointer: { show: false },
                progress: {
                  show: true,
                  overlap: false,
                  roundCap: true,
                  clip: false,
                  itemStyle: {
                    color: "#DC2626", // Default to red for 0
                  },
                },
                axisLine: {
                  lineStyle: {
                    width: 10,
                    color: [[1, "#E5E7EB"]],
                  },
                },
                splitLine: { show: false },
                axisTick: { show: false },
                axisLabel: { show: false },
                data: [{ value: 0 }],
                detail: { show: false },
              },
            ],
          };
          scoreChart.setOption(scoreOption);
        }
      }
    } catch (error) {
      console.error("Error fetching dashboard score:", error);
      setDashboardScore(0);
      // Handle error case with a red chart
      const scoreChart =
        scoreChartRef.current &&
        echarts.getInstanceByDom(scoreChartRef.current);
      if (scoreChart) {
        const scoreOption = {
          series: [
            {
              type: "gauge",
              startAngle: 90,
              endAngle: -270,
              pointer: { show: false },
              progress: {
                show: true,
                overlap: false,
                roundCap: true,
                clip: false,
                itemStyle: {
                  color: "#DC2626", // Default to red for errors
                },
              },
              axisLine: {
                lineStyle: {
                  width: 10,
                  color: [[1, "#E5E7EB"]],
                },
              },
              splitLine: { show: false },
              axisTick: { show: false },
              axisLabel: { show: false },
              data: [{ value: 0 }],
              detail: { show: false },
            },
          ],
        };
        scoreChart.setOption(scoreOption);
      }
    }
  };

  const fetchVulnerabilityCounts = async () => {
    try {
      // NOTE: Previously fetched via GET from 'securityscan/dashboard-cve-vulnerabilities'.
      // Backend removed 'dashboard-cve-vulnerabilities' API and consolidated the logic into 'dashboard-overall-vulnerabilities'.
      // It is now called using POST with payload { module: "dashboard-cve-vulnerabilities" }.
      const response = await axiosInstance.post(
        "securityscan/dashboard-overall-vulnerabilities",
        {
          module: "dashboard-cve-vulnerabilities",
        }
      );
      if (response.data.status === 200 && response.data.data) {
        // Check if cve_list is empty or if the data structure is different
        if (
          !response.data.data.critical &&
          !response.data.data.high &&
          !response.data.data.medium &&
          !response.data.data.low
        ) {
          setVulnerabilityCounts({
            critical: 0,
            high: 0,
            medium: 0,
            low: 0,
          });
          setIsAllZero(true);
        } else {
          setVulnerabilityCounts({
            critical: response.data.data.critical || 0,
            high: response.data.data.high || 0,
            medium: response.data.data.medium || 0,
            low: response.data.data.low || 0,
          });
          if (
            response.data.data.critical === 0 &&
            response.data.data.high === 0 &&
            response.data.data.medium === 0 &&
            response.data.data.low === 0
          ) {
            setIsAllZero(true);
          } else {
            setIsAllZero(false);
          }
        }
      } else {
        setVulnerabilityCounts({
          critical: 0,
          high: 0,
          medium: 0,
          low: 0,
        });
        setIsAllZero(true);
      }
    } catch (error) {
      console.error("Error fetching vulnerability counts:", error);
      setVulnerabilityCounts({
        critical: 0,
        high: 0,
        medium: 0,
        low: 0,
      });
      setIsAllZero(true);
    }
    setAnchorEl(null);
  };

  const handleSelectCVE = () => {
    setSelectedOption("CVE");
    setAnchorEl(null);
    fetchVulnerabilityCounts();
  };

  // Fetch summary APIs (dashboard score, vulnerability counts, vulnerability) on initial load and manual refresh only
  // These APIs are independent of tab changes
  useEffect(() => {
    setIsSummaryLoading(true);
    Promise.all([
      fetchDashboardScore(),
      fetchVulnerabilityCounts(),
      fetchVulnerability()
    ]).finally(() => {
      setIsSummaryLoading(false);
    });
  }, [trigger]);

  // Handle tab-specific data fetching when switching tabs or when state ID is provided
  useEffect(() => {
    // Only fetch data when actually switching tabs, not on initial render or unnecessary re-renders
    if (prevTabValueRef.current !== tabValue) {
      if (tabValue === 0) {
        fetchCVEData();
      } else if (tabValue === 1) {
        fetchAssetData();
      }
      prevTabValueRef.current = tabValue;
    } else if (trigger) {
      // Only fetch when trigger changes (for manual refresh / global filter)
      if (tabValue === 0) {
        fetchCVEData();
      } else if (tabValue === 1) {
        fetchAssetData();
      }
    } else if (location.state && (location.state as any).id) {
      if (tabValue === 0) {
        fetchCVEData();
      }
    }
  }, [tabValue, trigger, location.state?.id]);

  const fetchVulnerability = async () => {
    try {
      const response = await axiosInstance.get(
        "/securityscan/cve_vulnerability"
      );
      console.log("ResponsehandleVulnerabilityClick", response);
      if (response?.data.status === 200) {
        const vulnerabilityData = response?.data.data;
        console.log("Vulnerability Data:", vulnerabilityData);
        setTotalVulnerabilities(vulnerabilityData.count);
      }
    } catch (error) {
      console.error("Error fetching vulnerability data:", error);
    } finally {
      //setAnchorEl(null);
    }
  };

  useEffect(() => {
    const handleFilterSaved = () => {
      setIsLoading(true);
      setTrigger((prev) => prev + 1); // Changing this will re-trigger the effect
    };

    eventEmitter.on("filterSaved", handleFilterSaved);

    return () => {
      eventEmitter.off("filterSaved", handleFilterSaved);
    };
  }, []);

  useEffect(() => {
    const handleCloseAll = () => {
      setDrawerOpen(false);
      setAssetDrawerOpen(false);
      setReportDrawerOpen(false);
    };
    eventEmitter.on("closeAllDrawers", handleCloseAll);
    return () => {
      eventEmitter.off("closeAllDrawers", handleCloseAll);
    };
  }, []);

  // Initialize charts
  useEffect(() => {
    if (summaryExpanded && !isSummaryLoading) {
      // Determine the color based on the score
      let chartColor = "#22C55E"; // Green for >70
      if (dashboardScore < 50) {
        chartColor = "#DC2626"; // Red for <50
      } else if (dashboardScore >= 50 && dashboardScore <= 70) {
        chartColor = "#F97316"; // Orange for 50-70
      }

      // Initialize Score Chart
      const scoreChart =
        scoreChartRef.current && echarts.init(scoreChartRef.current);
      if (scoreChart) {
        const scoreOption = {
          series: [
            {
              type: "gauge",
              startAngle: 90,
              endAngle: -270,
              pointer: { show: false },
              progress: {
                show: true,
                overlap: false,
                roundCap: true,
                clip: false,
                itemStyle: {
                  color: chartColor, // Use the dynamic color
                },
              },
              axisLine: {
                lineStyle: {
                  width: 10,
                  color: [[1, "#E5E7EB"]],
                },
              },
              splitLine: { show: false },
              axisTick: { show: false },
              axisLabel: { show: false },
              data: [{ value: dashboardScore }],
              detail: { show: false },
            },
          ],
        };
        scoreChart.setOption(scoreOption);
      }

      // Initialize Vulnerability Chart
      const vulnChart =
        vulnerabilityChartRef.current &&
        echarts.init(vulnerabilityChartRef.current);
      if (vulnChart) {
        const vulnOption = {
          series: [
            {
              type: "pie",
              radius: ["70%", "90%"],
              startAngle: 180,
              endAngle: 360,
              center: ["50%", "65%"],
              data: isAllZero
                ? [
                  {
                    value: 1,
                    name: "Critical",
                    itemStyle: { color: "#D3D3D3" },
                  },
                ]
                : [
                  {
                    value: vulnerabilityCounts.critical,
                    name: "Critical",
                    itemStyle: { color: "#800006" },
                  },
                  {
                    value: vulnerabilityCounts.high,
                    name: "High",
                    itemStyle: { color: "#A7000F" },
                  },
                  {
                    value: vulnerabilityCounts.medium,
                    name: "Medium",
                    itemStyle: { color: "#E85800" },
                  },
                  {
                    value: vulnerabilityCounts.low,
                    name: "Low",
                    itemStyle: { color: "#F2BF00" },
                  },
                ],
              label: { show: false },
            },
          ],
        };
        vulnChart.setOption(vulnOption);
      }

      // Cleanup function
      return () => {
        scoreChart?.dispose();
        vulnChart?.dispose();
      };
    }
  }, [summaryExpanded, isSummaryLoading, dashboardScore, vulnerabilityCounts, isAllZero, trigger]);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      const charts = [
        scoreChartRef.current &&
        echarts.getInstanceByDom(scoreChartRef.current),
        vulnerabilityChartRef.current &&
        echarts.getInstanceByDom(vulnerabilityChartRef.current),
      ];
      charts.forEach((chart) => chart?.resize());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [trigger]);

  const columnDefs: ColDef[] = [
    {
      field: "id",
      headerName: "#",
      maxWidth: 85,
      minWidth: 70,
      filter: false,
      valueGetter: (params: any) => params.node.rowIndex + 1,
    },
    {
      field: "cve_id",
      headerName: "CVE",
      width: 120,
      minWidth: 100,
      maxWidth: 150,
      cellRenderer: (params: ICellRendererParams) => (
        <Typography
          variant="body2"
          sx={{
            color: isDarkMode ? "#FFFFFF" : "#000000",
            cursor: "pointer",
            fontWeight: 700,
            fontSize: "12px",
          }}
          onClick={() => handleCVEClick(params.data)}
        >
          {params.value}
        </Typography>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "score",
      headerName: "CVSS",
      minWidth: 120,
      maxWidth: 130,
      cellRenderer: (params: ICellRendererParams) => (
        <Typography
          variant="body2"
          sx={{ fontWeight: 700, fontSize: "12px" }}
          onClick={() => handleCVEClick(params.data)}
        >
          {params.value}
        </Typography>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "severity",
      headerName: "Severity",
      minWidth: 120,
      maxWidth: 180,
      cellRenderer: (params: ICellRendererParams) => {
        const severity = params.value?.toLowerCase();
        let chipColor = "";
        let bgColor = "";

        if (isDarkMode) {
          switch (severity) {
            case "critical":
              chipColor = "#FF3D3D";
              bgColor = "rgba(255, 61, 61, 0.18)";
              break;
            case "high":
              chipColor = "#FF6B6B";
              bgColor = "rgba(255, 107, 107, 0.15)";
              break;
            case "medium":
              chipColor = "#FFA726";
              bgColor = "rgba(255, 167, 38, 0.15)";
              break;
            case "low":
              chipColor = "#FFE082";
              bgColor = "rgba(255, 224, 130, 0.15)";
              break;
            default:
              chipColor = "#E0E0E0";
              bgColor = "rgba(255, 255, 255, 0.08)";
          }
        } else {
          switch (severity) {
            case "critical":
              chipColor = "#670004";
              bgColor = "#67000424";
              break;
            case "high":
              chipColor = "#A7000F";
              bgColor = "#A7000F24";
              break;
            case "medium":
              chipColor = "#E85800";
              bgColor = "#E8580024";
              break;
            case "low":
              chipColor = "#F2BF00";
              bgColor = "#F2BF0024";
              break;
            default:
              chipColor = "#6c6c6c";
              bgColor = "rgba(255, 255, 255, 0.07)";
          }
        }

        return (
          <Chip
            label={params.value}
            size="small"
            icon={
              <FiberManualRecordIcon
                fontSize="small"
                style={{ color: chipColor, fontSize: 14 }}
              />
            }
            sx={{
              borderRadius: 1,
              bgcolor: bgColor,
              color: chipColor,
              fontWeight: 600,
              fontSize: 12,
              px: 1.5,
              height: 24,
            }}
            onClick={() => handleCVEClick(params.data)}
          />
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "cve_issued_date",
      headerName: "CVE Issued Date",
      minWidth: 180,
      maxWidth: 220,
      cellRenderer: (params: ICellRendererParams) => {
        const dateValue = params.value;
        let formattedDate = "-";

        if (dateValue) {
          const momentDate = moment(dateValue);
          if (momentDate.isValid()) {
            formattedDate = momentDate.format("DD-MMM-YYYY HH:mm:ss");
          }
        }

        return (
          <Typography
            variant="body2"
            sx={{ fontWeight: 700, fontSize: "12px" }}
          >
            {formattedDate}
          </Typography>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "cisas_kev",
      headerName: "CISA's KEV",
      width: 100,
      minWidth: 100,
      maxWidth: 150,
      headerComponent: () => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <span>CISA's KEV</span>
          <Tooltip title="Known Exploited Vulnerabilities">
            <IconButton size="small">
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
      cellRenderer: (params: ICellRendererParams) => (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 700,
            fontSize: "12px",
            color: params.value
              ? "#F53B3B"
              : isDarkMode
                ? "#FFFFFF"
                : "#000000",
          }}
        >
          {params.value ? "Exploited " : "Not Exploited"}
        </Typography>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "epss",
      headerName: "EPSS",
      width: 80,
      minWidth: 80,
      maxWidth: 100,
      headerComponent: () => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <span>EPSS</span>
          <Tooltip title="Exploit Prediction Scoring System">
            <IconButton size="small">
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
      cellRenderer: (params: ICellRendererParams) => {
        const epssValue = parseFloat(params.value);
        return (
          <Typography
            variant="body2"
            sx={{ fontWeight: 700, fontSize: "12px" }}
          >
            {params.value != null && !isNaN(epssValue)
              ? `${(epssValue * 100).toFixed(2)}%`
              : "N/A"}
          </Typography>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "vector_string",
      headerName: "Vector",
      width: 300,
      minWidth: 300,
      cellRenderer: (params: ICellRendererParams) => {
        const cvssData = params.data.cvss_data?.[0];
        const metrics = cvssData?.severity_metrics?.values || [];
        const topic = cvssData?.severity_metrics?.topic;
        return (
          <Typography
            variant="body2"
            data-prevent-row-click="true"
            sx={{
              fontWeight: 700,
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              width: "100%",
              cursor: "pointer",
              fontSize: "12px",
              padding: "4px 8px",
              margin: "-4px -8px",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.04)",
              },
            }}
            onClick={(event) => {
              event.stopPropagation();
              handlePopoverOpen(event, params.value, metrics, topic);
            }}
          >
            {params.value}
          </Typography>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "asset_count",
      headerName: "Affected Assets",
      minWidth: 150,
      maxWidth: 200,
      cellRenderer: (params: ICellRendererParams) => (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 700,
            fontSize: "12px",
            color: "#DC2626",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
            padding: "4px 8px",
            margin: "-4px -8px",
            borderRadius: "4px",
            "&:hover": {
              backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.04)",
            },
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleCVEClick(params.data, 1);
          }}
        >
          <img
            src={params.value > 0 ? cveBugError : cveBug}
            alt="CVE"
            style={{ width: "20px", height: "20px" }}
          />
          {params.value}
        </Typography>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    // {
    //   field: "cve_last_updated",
    //   headerName: "Last Updated",
    //   width: 250,
    //   minWidth: 250,
    //   cellRenderer: (params: ICellRendererParams) => {
    //     if (!params.value) return "";
    //     const date = moment(params.value);
    //     return (
    //       <Box display="flex" alignItems="center">
    //         <Typography
    //           title={date.format("DD MMM YYYY HH:mm:ss")}
    //           sx={{
    //             textOverflow: "ellipsis",
    //             overflow: "hidden",
    //             whiteSpace: "nowrap",
    //             fontWeight: 600,
    //           }}
    //           onClick={() => handleCVEClick(params.data)}
    //         >
    //           {date.format("DD MMM YYYY HH:mm:ss")}
    //         </Typography>
    //       </Box>
    //     );
    //   },
    //   cellStyle: {
    //     display: "flex",
    //     alignItems: "center",
    //   },
    // },
  ];
  // Framework columns only for frameworks switched on for the organization
  const generateNISTColumns = (data: any[]) => {
    if (!data || data.length === 0) return [];
    const nistKeys = Object.keys(data[0]).filter((key) =>
      key.startsWith("NIST_") && isFrameworkKeyOn(key)
    );
    return nistKeys.map((key, index) => ({
      field: key,
      valueGetter: key.includes(".")
        ? (params: any) => params.data[key]
        : undefined,
      headerName: key,
      filter: true,
      minWidth: 180,
      showNist: index === 0,
      cellRenderer: (params: any) => {
        if (params.data?.status !== 3) {
          return null;
        }
        const rawValue = Number(params.value) || 0;
        const value = Math.round(rawValue); // ✅ Round to nearest whole number

        const progressColor =
          value >= 75 ? "green" : value >= 50 ? "orange" : "red";

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              whiteSpace: "nowrap",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: 30,
                height: 30,
              }}
            >
              {/* Background circle */}
              <CircularProgress
                variant="determinate"
                value={100}
                size={30}
                thickness={5}
                sx={{ color: "#c5c5d2" }}
              />
              {/* Foreground progress */}
              <CircularProgress
                variant="determinate"
                value={value}
                size={30}
                thickness={5}
                sx={{
                  color: progressColor,
                  position: "absolute",
                  left: 0,
                  top: 0,
                }}
              />
            </Box>
            <Typography variant="body2" fontWeight={600}>
              {`${value}%`}
            </Typography>
          </Box>
        );
      },

      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    }));
  };
  const generateCISColumns = (data: any[]) => {
    if (!data || data.length === 0) return [];
    const cisKeys = Object.keys(data[0]).filter((key) =>
      key.startsWith("CIS_") && isFrameworkKeyOn(key)
    );
    return cisKeys.map((key, index) => ({
      field: key,
      valueGetter: key.includes(".")
        ? (params: any) => params.data[key]
        : undefined,
      headerName: key,
      filter: true,
      minWidth: 180,
      // showNist: index === 0,
      showNist: false,
      cellRenderer: (params: any) => {
        if (params.data?.status !== 3) {
          return null;
        }
        const rawValue = Number(params.value) || 0;
        const value = Math.round(rawValue);

        const progressColor =
          value >= 75 ? "green" : value >= 50 ? "orange" : "red";

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              whiteSpace: "nowrap",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: 30,
                height: 30,
              }}
            >
              {/* Background circle */}
              <CircularProgress
                variant="determinate"
                value={100}
                size={30}
                thickness={5}
                sx={{ color: "#c5c5d2" }}
              />
              {/* Foreground progress */}
              <CircularProgress
                variant="determinate"
                value={value}
                size={30}
                thickness={5}
                sx={{
                  color: progressColor,
                  position: "absolute",
                  left: 0,
                  top: 0,
                }}
              />
            </Box>
            <Typography variant="body2" fontWeight={600}>
              {`${value}%`}
            </Typography>
          </Box>
        );
      },

      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    }));
  };
  const generatePCIColumns = (data: any[]) => {
    if (!data || data.length === 0) return [];
    const pciKeys = Object.keys(data[0]).filter((key) => key.startsWith("PCI") && isFrameworkKeyOn(key));
    return pciKeys.map((key, index) => ({
      field: key,
      valueGetter: key.includes(".")
        ? (params: any) => params.data[key]
        : undefined,
      headerName: key,
      filter: true,
      minWidth: 180,
      // showNist: index === 0,
      showNist: false,
      cellRenderer: (params: any) => {
        if (params.data?.status !== 3) {
          return null;
        }
        const rawValue = Number(params.value) || 0;
        const value = Math.round(rawValue); // ✅ Round to nearest whole number

        const progressColor =
          value >= 75 ? "green" : value >= 50 ? "orange" : "red";

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              whiteSpace: "nowrap",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: 30,
                height: 30,
              }}
            >
              {/* Background circle */}
              <CircularProgress
                variant="determinate"
                value={100}
                size={30}
                thickness={5}
                sx={{ color: "#c5c5d2" }}
              />
              {/* Foreground progress */}
              <CircularProgress
                variant="determinate"
                value={value}
                size={30}
                thickness={5}
                sx={{
                  color: progressColor,
                  position: "absolute",
                  left: 0,
                  top: 0,
                }}
              />
            </Box>
            <Typography variant="body2" fontWeight={600}>
              {`${value}%`}
            </Typography>
          </Box>
        );
      },

      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    }));
  };


  const nistColumns = generateNISTColumns(assetData);
  const cisColumns = generateCISColumns(assetData);
  const pciColumns = generatePCIColumns(assetData);



  const assetColumnDefs: ColDef[] = [
    {
      field: "id",
      headerName: "#",
      maxWidth: 100,
      minWidth: 80,
      valueGetter: (params) => {
        return params.node?.rowIndex ? params.node.rowIndex + 1 : 1;
      },
      sortable: true,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "device_name",
      headerName: "Asset Name",
      flex: 1,
      minWidth: 150,
      maxWidth: 180,
      sortable: true,
      cellRenderer: (params: ICellRendererParams) => {
        // let criticalityColor = "#22C55E"; // Default green
        // if (params.data.cve > 5) {
        //   criticalityColor = "#F97316"; // Orange for high
        // } else if (params.data.cve > 2) {
        //   criticalityColor = "#EAB308"; // Yellow for medium
        // }

        const criticalityColors: any = {
          critical: "#B71E31",
          high: "#FF6600",
          medium: "#E0B102",
          low: "#00A61B",
          default: "#B71E31",
        };

        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            {/* <Box
              sx={{
                width: "4px",
                height: "24px",
                backgroundColor: criticalityColor,
                borderRadius: "2px",
              }}
            /> */}
            <div
              style={{
                width: "4px",
                height: "32px",
                backgroundColor:
                  criticalityColors[params?.data?.criticality?.toLowerCase()] ||
                  "#B71E31",

                borderRadius: "2px",
                marginRight: "8px",
                flexShrink: 0,
              }}
            />
            <Typography variant="body2">{params.value}</Typography>
          </Box>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "device_type",
      headerName: "Type",
      flex: 1,
      minWidth: 100,
      maxWidth: 120,
      sortable: true,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "model",
      headerName: "OS",
      flex: 1,
      minWidth: 100,
      maxWidth: 120,
      sortable: true,
      valueFormatter: (params) => {
        return params.value ? params.value.toUpperCase() : "";
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "vendor",
      headerName: "Vendor",
      minWidth: 150,
      maxWidth: 180,
      flex: 1,
      sortable: true,
      // cellRenderer: (params: ICellRendererParams) => {
      //   const vendorLogos:any = {
      //     cisco: isDarkMode ? cisco_dark : ciscoLogo,
      //     paloalto: isDarkMode ? paloalto_dark : paloaltoLogo,
      //     arista: isDarkMode ? arista_dark : aristaLogo,
      //     juniper: isDarkMode ? juniper_dark : juniperLogo,
      //     "palo alto": isDarkMode ? paloalto_dark : paloaltoLogo,
      //   };
      //   return (
      //     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      //       <img
      //         src={vendorLogos[params.value?.toLowerCase()]}
      //         alt={params.value}
      //         style={{ width: "30px", height: "24px", objectFit: "contain" }}
      //       />
      //       <Typography variant="body2">
      //         {params.value
      //           ? params.value.charAt(0).toUpperCase() + params.value.slice(1)
      //           : ""}
      //       </Typography>
      //     </Box>
      //   );
      // },
      cellRenderer: (params: any) => {
        //cisco: isDarkMode ? cisco_dark : ciscoLogo,
        //     paloalto: isDarkMode ? paloalto_dark : paloaltoLogo,
        //     arista: isDarkMode ? arista_dark : aristaLogo,
        //     juniper: isDarkMode ? juniper_dark : juniperLogo,
        //     "palo alto": isDarkMode ? paloalto_dark : paloaltoLogo,
        const vendorLogos: any = {
          cisco: isDarkMode ? cisco_dark : ciscoLogo,
          paloalto: isDarkMode ? paloalto_dark : paloaltoLogo,
          arista: isDarkMode ? arista_dark : aristaLogo,
          juniper: isDarkMode ? juniper_dark : juniperLogo,
          debian: isDarkMode ? debian_dark : debian,
          fortinet: isDarkMode ? fortinet_dark : fortinetLogo,
          forti: isDarkMode ? fortinet_dark : fortinetLogo,
          fortigate: isDarkMode ? fortinet_dark : fortinetLogo,
          ubuntu: isDarkMode ? ubuntu_dark : ubuntu_light,
          sophos: isDarkMode ? sophos_dark : sophosLogo,
          microsoft: isDarkMode ? windows_dark : windows_light,
          windows: isDarkMode ? windows_dark : windows_light,
          redhat: isDarkMode ? redhat_dark : redhat_light,
          huawei: isDarkMode ? huawei_dark : huawei_light,
          mikrotik: isDarkMode ? mikrotik_dark : mikrotik,
          edgecore: edgecore_logo,
          "tp-link": isDarkMode ? tplink_dark : tplink_light,
          tplink: isDarkMode ? tplink_dark : tplink_light,
          dell: dell_logo,
          syrotech: isDarkMode ? syrotech_dark : syrotech_light,
        };

        const normalizedVendor = params.value?.toLowerCase().replace(/\s/g, "");
        const logoSrc = vendorLogos[normalizedVendor];

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              mt: 1.5,
            }}
          >
            {logoSrc ? (
              <img
                src={logoSrc}
                alt={params.value}
                style={{
                  maxWidth: "80px",
                  width: "100%",
                  height: "24px",
                  objectFit: "contain",
                }}
              />
            ) : (
              <span>{params.value}</span>
            )}
          </Box>
        );
      },

      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "region_name",
      headerName: "Region",
      flex: 1,
      minWidth: 170,
      maxWidth: 200,
      sortable: true,
      cellRenderer: (params: ICellRendererParams) => (
        <Box sx={{ width: "150px", overflow: "hidden" }}>
          <Tooltip title={params.value} placement="top">
            <Typography
              variant="body2"
              noWrap
              sx={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                width: "100%",
              }}
            >
              {params.value}
            </Typography>
          </Tooltip>
        </Box>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
        padding: "0 16px",
      },
    },
    {
      field: "cve",
      headerName: "CVE's",
      flex: 1,
      minWidth: 100,
      maxWidth: 120,
      cellRenderer: (params: ICellRendererParams) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img
            src={params.value > 0 ? cveBugError : cveBug}
            alt="CVE"
            style={{ width: "20px", height: "20px" }}
          />
          <Typography
            variant="body2"
            color={params.value > 0 ? "error" : "textPrimary"}
          >
            {params.value}
          </Typography>
        </Box>
      ),
      sortable: true,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "last_scan",
      headerName: "Last Scan",
      minWidth: 190,
      maxWidth: 220,
      flex: 1.2,
      cellRenderer: (params: ICellRendererParams) => {
        if (!params.value) return "";
        const date = moment(params.value);
        return (
          <Box display="flex" alignItems="center">
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.mode === "dark" ? "#FFFFFF" : "#000000", // Match color
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
              title={date.format("DD MMM YYYY HH:mm:ss")} // Tooltip for full date
            >
              {date.format("DD MMM YYYY HH:mm:ss")}
            </Typography>
          </Box>
        );
      },
      sortable: true,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    ...nistColumns,
    ...cisColumns,
    ...pciColumns,
  ];

  const defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100,
  };

  const gridOptions: GridOptions = {
    defaultColDef,
    rowHeight: 48,
    headerHeight: 48,
    suppressCellFocus: true,
    rowStyle: { cursor: "pointer" },
    suppressRowClickSelection: true,
    rowMultiSelectWithClick: false,
    enableCellTextSelection: true,
    ensureDomOrder: true,
    getRowId: (params) => String(params.data?.id ?? params.data?.device_id ?? params.data?.cve_id ?? params.data?.device_name ?? params.data?.name ?? ''),
  };

  const handleAssetRowClick = (rowData: AssetData) => {
    console.log("Asset row clicked:", rowData);
    setSelectedAsset(rowData);
    setAssetDrawerOpen(true);
    console.log("Drawer state after click:", {
      selectedAsset: rowData,
      drawerOpen: true,
    });
  };
  const { saveToLocalStorage } = useStorageManager();
  const navigate = useNavigate();
  const [isNewUserTrue, setIsNewUserTrue] = useState(false);
  const [totalVulnerabilities, setTotalVulnerabilities] = useState(0);
  useEffect(() => {
    const checkIfNewUser = async () => {
      // Optional: read from localStorage first
      // const cachedData = JSON.parse(getFromLocalStorage("isNewUserDetails") || "{}");
      // console.log(cachedData);
      // if (cachedData) {
      //   setIsNewUserTrue(cachedData.new_user && cachedData.device_count === 0);
      //   return;
      // }

      try {
        const res = await axiosInstance.get(END_POINTS.IS_NEW_USER);
        if (res.status === 200) {
          const isNewUser = res?.data?.data || false;
          saveToLocalStorage("isNewUserDetails", isNewUser);
          console.log(isNewUser);
          if (isNewUser) {
            setIsNewUserTrue(
              isNewUser.new_user && isNewUser.device_count === 0
            );
          }
        }
      } catch (error) {
        console.error("Failed to fetch new user details:", error);
      }
    };

    checkIfNewUser();
  }, [trigger]);

  const handleShowConfig = (deviceId: any, selectDevice: any = null) => {
    dispatch(
      setConfigDiffData({
        rowData: selectDevice,
        device_id: String(deviceId),

        click: "assets",
      })

    );
    navigate(`/on-premises/configdiff`, {
      state: { device_id: String(deviceId) }
    });
  };

  const handleMenuAction = (action: string) => {
    switch (action) {
      case "ShowConfigDiff":
        if (selectedAsset?.id) {
          handleShowConfig(selectedAsset.id, selectedAsset);
        }
        break;
    }
    handleMenuKebabClose();
  };

  const MenuKebabDrawer = (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <IconButton
        size="small"
        onClick={handleMenuKebabClick}
        sx={{
          color: "text.secondary",
          "&:hover": {
            backgroundColor: "action.hover",
          },
        }}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={menuAnchorEl}
        open={menuOpen}
        onClose={handleMenuKebabClose}
        onClick={(e) => e.stopPropagation()}
        PaperProps={{
          sx: {
            width: 200,
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        {/* {hasPermissions(ROLES_CONTENT_PROPS.DECOMMISSION_DEVICE) && (
            <MenuItem onClick={() => handleMenuAction("DeCommission")}>
              Decommission
            </MenuItem>
          )} */}
        <MenuItem onClick={() => handleMenuAction("ShowConfigDiff")}>
          Show Config Diff
        </MenuItem>
      </Menu>
    </Box>
  );
  return (
    <>
      {isNewUserTrue ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "80vh",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "center", width: "100%", mb: 2 }}>
            <img src={NoData_img1} alt="" style={{ width: 150, display: "block", margin: "0 auto" }} />
          </Box>
          <Typography
            variant="body2"
            sx={{ fontWeight: 700, fontSize: "18px", mt: 2, mb: 2 }}
          >
            There is no asset available,
          </Typography>
          {hasPermissions(ROLES_ROUTE.NEW_SCAN) ? (
            <>
              <Typography
                variant="body2"
                sx={{ fontWeight: 450, fontSize: "15px" }}
              >
                Scan your assets to view CVE information. To add an asset, click
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 450, fontSize: "15px", mb: 3 }}
              >
                the "New Scan" button in the top right corner, or click below.
              </Typography>
              <Button
                variant="contained"
                onClick={() => navigate("/on-premises/new-newscan")}
              >
                Scan Now
              </Button>
            </>
          ) : (
            <Typography
              variant="body2"
              sx={{ fontWeight: 450, fontSize: "15px", mb: 3 }}
            >
              No CVE data found.
            </Typography>
          )}
        </Box>
      ) : (
        <>
          <Box
            sx={{
              // height: "calc(100vh - 140px)",
              height: "calc(100vh - 90px)",
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
            }}
          >
            {/* Summary Card */}
            <Paper
              elevation={1}
              sx={{
                borderRadius: "8px",
                border: `1px solid ${theme.palette.mode === "dark" ? "#2D2D2D" : "#E5E7EB"
                  }`,
                bgcolor:
                  theme.palette.mode === "dark" ? "background.paper" : "white",
                width: "100%",
                // Dynamically set height
                //height: summaryExpanded ? "30vh" : "50px",
                transition: "height 0.3s",
                minHeight: "50px",
                maxHeight: summaryExpanded ? "30vh" : "50px",
                overflow: "hidden",
              }}
            >
              <Accordion
                expanded={summaryExpanded}
                onChange={handleSummaryChange}
                sx={{
                  "&:before": { display: "none" },
                  boxShadow: "none",
                  // height: summaryExpanded ? "200px" : "50px",
                  height: "100%",
                  borderRadius: "8px",
                  "& .MuiAccordionSummary-root": {
                    minHeight: "32px",
                    pl: 2,
                    pr: 2,
                    py: 0.5,
                  },
                }}
              >
                <AccordionSummary
                  sx={{
                    bgcolor:
                      theme.palette.mode === "dark"
                        ? "background.paper"
                        : "white",
                    borderRadius: "8px 8px 0 0",
                    "&.Mui-expanded": {
                      borderBottom: `1px solid ${theme.palette.mode === "dark" ? "#2D2D2D" : "#E5E7EB"
                        }`,
                    },
                    position: "relative", // Add relative positioning for absolute child
                  }}
                >
                  {/* Download icon - positioned absolutely in rightmost corner when expanded */}
                  {summaryExpanded && (
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent accordion toggle
                        setIsReportDialogOpen(true);
                      }}
                      sx={{
                        position: "absolute",
                        top: "50%",
                        right: 52,
                        transform: "translateY(-50%)",
                        zIndex: 10,
                        "&:hover": {
                          backgroundColor: "action.hover",
                        },
                      }}
                    >
                      <DownloadIcon fontSize="small" />
                    </IconButton>
                  )}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {/* Dynamically render the icon based on the expanded state */}
                    {isSummaryLoading ? (
                      <Skeleton
                        variant="circular"
                        width={24}
                        height={24}
                        sx={{ mr: 1 }}
                      />
                    ) : summaryExpanded ? (
                      <ExpandMoreIcon
                        sx={{
                          transform: "rotate(180deg)",
                          color:
                            theme.palette.mode === "dark"
                              ? "#FFFFFF"
                              : "#000000",
                        }}
                      />
                    ) : (
                      <ExpandMoreIcon
                        sx={{
                          color:
                            theme.palette.mode === "dark"
                              ? "#FFFFFF"
                              : "#000000",
                        }}
                      />
                    )}
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 800,
                        fontSize: "14px",
                        color:
                          theme.palette.mode === "dark" ? "#FFFFFF" : "#000000",
                      }}
                    >
                      {summaryExpanded ? (
                        isSummaryLoading ? (
                          <Skeleton
                            variant="text"
                            width={100}
                            height={24}
                            sx={{ mb: 0.5 }}
                          />
                        ) : (
                          <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: 700 }}
                          >
                            SUMMARY
                          </Typography>
                        )
                      ) : (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 1,
                            width: "90vw",
                          }}
                        >
                          {isSummaryLoading ? (
                            <Skeleton
                              variant="text"
                              width={100}
                              height={24}
                              sx={{ mb: 0.5 }}
                            />
                          ) : (
                            <Typography
                              variant="subtitle1"
                              sx={{ fontWeight: 800, fontSize: "14px" }}
                            >
                              SUMMARY
                            </Typography>
                          )}
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              gap: 1,
                              alignItems: "center",
                            }}
                          >
                            {/* CVE Score */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Typography
                                // variant="body2"
                                sx={{ fontWeight: 800, fontSize: "14px" }}
                              >
                                CVE Score:
                              </Typography>
                              <Box sx={{ width: 40 }}>
                                <LinearProgress
                                  variant="determinate"
                                  value={dashboardScore}
                                  sx={{
                                    height: 6,
                                    borderRadius: 3,
                                    bgcolor: "#f5f5f5",
                                    "& .MuiLinearProgress-bar": {
                                      bgcolor:
                                        dashboardScore >= 70
                                          ? "#4caf50"
                                          : dashboardScore >= 40
                                            ? "#ff9800"
                                            : "#f44336",
                                    },
                                  }}
                                />
                              </Box>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: "bold", ml: 1 }}
                              >
                                {dashboardScore}
                              </Typography>
                            </Box>
                            <Divider orientation="vertical" flexItem />

                            {/* Unique CVE */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: "bold" }}
                              >
                                Unique CVE:
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: "bold" }}
                              >
                                {cveData.length}
                              </Typography>
                            </Box>
                            <Divider orientation="vertical" flexItem />

                            {/* Total Vulnerabilities */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: "bold" }}
                              >
                                Total Vulnerabilities:
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: "bold" }}
                              >
                                {totalVulnerabilities}
                              </Typography>
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent accordion toggle
                                  setIsReportDialogOpen(true);
                                }}
                                sx={{
                                  ml: 1,
                                  "&:hover": {
                                    backgroundColor: "action.hover",
                                  },
                                }}
                              >
                                <DownloadIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </Box>
                        </Box>
                      )}
                      {/* Summary */}
                    </Typography>
                  </Box>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    // height: summaryExpanded ? "30vh" : "0",
                    height: summaryExpanded ? "calc(100% - 48px)" : "0",
                    bgcolor:
                      theme.palette.mode === "dark"
                        ? "background.paper"
                        : "white",
                    padding: 0,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      height: "100%",

                      alignItems: "stretch",
                      "& > *:not(:last-child)": {
                        borderRight: `1px solid ${theme.palette.mode === "dark" ? "#2D2D2D" : "#E5E7EB"
                          }`,
                        height: "100%",
                      },
                    }}
                  >
                    {/* CVE Score Widget */}
                    <Box
                      sx={{
                        width: "20%",
                        pt: 0.5,
                        pb: 2,
                        pl: 2,
                        pr: 2,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {isSummaryLoading ? (
                        <>
                          <Skeleton
                            variant="text"
                            width={100}
                            height={24}
                            sx={{ mb: 2 }}
                          />
                          <Box sx={{ flex: 1, position: "relative", minHeight: 80 }}>
                            <Skeleton
                              variant="rectangular"
                              width="100%"
                              height={80}
                              sx={{
                                borderRadius: 2,
                                animation: "pulse 1.5s ease-in-out infinite",
                                "@keyframes pulse": {
                                  "0%": { opacity: 0.3 },
                                  "50%": { opacity: 0.6 },
                                  "100%": { opacity: 0.3 },
                                },
                              }}
                            />
                          </Box>
                        </>
                      ) : (
                        <>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: "800",
                              fontSize: "14px",

                              color:
                                theme.palette.mode === "dark"
                                  ? "#FFFFFF"
                                  : "textSecondary",
                            }}
                          >
                            CVE Score
                          </Typography>
                          <Box
                            sx={{
                              flex: 1,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Box
                              sx={{
                                position: "relative",
                                width: 120,
                                height: 120,
                              }}
                            >
                              <Box
                                ref={scoreChartRef}
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  cursor: "default",
                                  "& *": { cursor: "default !important" }
                                }}
                              />
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  variant="h5"
                                  sx={{
                                    fontWeight: 800,

                                    color:
                                      theme.palette.mode === "dark"
                                        ? "#FFFFFF"
                                        : "#000000",
                                  }}
                                >
                                  {dashboardScore}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        </>
                      )}
                    </Box>

                    {/* Vulnerabilities Widget */}
                    <Box
                      sx={{
                        width: "20%",
                        pt: 0.5,
                        pb: 0.5,
                        pl: 2,
                        pr: 2,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {isSummaryLoading ? (
                        <>
                          <Skeleton
                            variant="text"
                            width={100}
                            height={24}
                            sx={{ mb: 2 }}
                          />
                          <Box sx={{ flex: 1, position: "relative", minHeight: 80 }}>
                            <Skeleton
                              variant="rectangular"
                              width="100%"
                              height={80}
                              sx={{
                                borderRadius: 2,
                                animation: "pulse 1.5s ease-in-out infinite",
                                "@keyframes pulse": {
                                  "0%": { opacity: 0.3 },
                                  "50%": { opacity: 0.6 },
                                  "100%": { opacity: 0.3 },
                                },
                              }}
                            />
                          </Box>
                        </>
                      ) : (
                        <>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: 2,
                            }}
                          >
                            <Typography
                              variant="subtitle2"
                              sx={{
                                fontWeight: 800,
                                fontSize: "14px",
                                color:
                                  theme.palette.mode === "dark"
                                    ? "#FFFFFF"
                                    : "textSecondary",
                              }}
                            >
                              {selectedOption}
                            </Typography>
                            <ArrowDropDownIcon
                              id="basic-button"
                              aria-controls={open ? "basic-menu" : undefined}
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              onClick={handleClick}
                              sx={{ cursor: "pointer" }}
                            />
                            <Menu
                              id="basic-menu"
                              anchorEl={anchorEl}
                              open={open}
                              onClose={handleClose}
                              MenuListProps={{
                                "aria-labelledby": "basic-button",
                              }}
                              PaperProps={{
                                sx: {
                                  bgcolor: theme.palette.mode === "dark" ? "#2D2D2D" : "#FFFFFF",
                                  border: theme.palette.mode === "dark" ? "1px solid #404040" : "none",
                                },
                              }}
                            >
                              <MenuItem
                                onClick={() => handleSelectCVE("CVE")}
                                sx={{
                                  color:
                                    theme.palette.mode === "dark"
                                      ? "#FFFFFF"
                                      : selectedOption === "CVE"
                                        ? "#3A2ADA"
                                        : "#000000",
                                  fontWeight: "bold",
                                }}
                              >
                                CVE
                              </MenuItem>
                              <MenuItem
                                onClick={() =>
                                  handleSelecVulnerability("Vulnerabilities")
                                }
                                sx={{
                                  color:
                                    theme.palette.mode === "dark"
                                      ? "#FFFFFF"
                                      : selectedOption === "Vulnerabilities"
                                        ? "#3A2ADA"
                                        : "#000000",
                                  fontWeight: "bold",
                                }}
                              >
                                Vulnerabilities
                              </MenuItem>
                            </Menu>
                          </div>
                          <Box
                            sx={{
                              flex: 1,
                              display: "flex",
                              flexDirection: "column",
                              position: "relative",
                            }}
                          >
                            <Box
                              sx={{ flex: 1, }}
                            >
                              <Box
                                ref={vulnerabilityChartRef}
                                sx={{
                                  width: "100%",
                                  height: "120px",
                                  marginTop: "-12px",
                                  cursor: "default",
                                  "& *": { cursor: "default !important" }
                                }}
                              />
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: "40%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  textAlign: "center",
                                }}
                              >
                                <Typography
                                  variant="h5"
                                  sx={{
                                    fontWeight: "900",
                                    fontSize: "20px",
                                    // fontFamily: "Geologica",
                                    color:
                                      theme.palette.mode === "dark"
                                        ? "#FFFFFF"
                                        : "#000000",
                                    mb: 0.5,
                                  }}
                                >
                                  {vulnerabilityCounts.critical +
                                    vulnerabilityCounts.high +
                                    vulnerabilityCounts.medium +
                                    vulnerabilityCounts.low}
                                </Typography>
                              </Box>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                gap: 2,
                                mt: -4,
                                "& > *:not(:last-child)": {
                                  borderRight: `1px solid ${theme.palette.mode === "dark"
                                    ? "#2D2D2D"
                                    : "#E5E7EB"
                                    }`,
                                  pr: 2,
                                },
                              }}
                            >
                              <Box sx={{ textAlign: "center" }}>
                                <Typography
                                  variant="caption"
                                  color="error.main"
                                  sx={{ fontWeight: "700", fontSize: "12px" }}
                                >
                                  Critical
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 700,
                                    // color:
                                    //   theme.palette.mode === "dark"
                                    //     ? "#FFFFFF"
                                    //     : "#800006",
                                  }}
                                >
                                  {vulnerabilityCounts.critical}
                                </Typography>
                              </Box>
                              <Box sx={{ textAlign: "center" }}>
                                <Typography
                                  variant="caption"
                                  color="warning.main"
                                  sx={{ fontWeight: "700", fontSize: "12px" }}
                                >
                                  High
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 700,
                                    // color:
                                    //   theme.palette.mode === "dark"
                                    //     ? "#FFFFFF"
                                    //     : "#A7000F",
                                  }}
                                >
                                  {vulnerabilityCounts.high}
                                </Typography>
                              </Box>
                              <Box sx={{ textAlign: "center" }}>
                                <Typography
                                  variant="caption"
                                  color="#E85800"
                                  sx={{ fontWeight: "700", fontSize: "12px" }}
                                >
                                  Medium
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 700,
                                    // color:
                                    //   theme.palette.mode === "dark"
                                    //     ? "#FFFFFF"
                                    //     : "#E85800",
                                  }}
                                >
                                  {vulnerabilityCounts.medium}
                                </Typography>
                              </Box>
                              <Box sx={{ textAlign: "center" }}>
                                <Typography
                                  variant="caption"
                                  color="#F2BF00"
                                  sx={{ fontWeight: "700", fontSize: "12px" }}
                                >
                                  Low
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 700,
                                    // color:
                                    //   theme.palette.mode === "dark"
                                    //     ? "#FFFFFF"
                                    //     : "#F2BF00",
                                  }}
                                >
                                  {vulnerabilityCounts.low}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        </>
                      )}
                    </Box>

                    {/* CyberResilienceView™ - CVE Widget */}
                    <Box
                      sx={{
                        width: "60%",
                        height: "100%",
                        pt: 0.5,
                        pb: 0.5,
                        pl: 2,
                        pr: 2,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {/* <Typography 
                                    variant="subtitle2" 
                                    sx={{ 
                                        mb: 2,
                                        textAlign: 'left',
                                        height: '20px',
                                        lineHeight: '20px',
                                        fontWeight: 600,
                                        fontSize: '18px',
                                        color: theme.palette.mode === 'dark' ? '#FFFFFF' : 'textSecondary'
                                    }}
                                >
                                    CyberResilienceView™ - CVE
                                </Typography> */}
                      <Box sx={{ flex: 1 }}>
                        <CVETimelineView height="100%" />
                      </Box>
                    </Box>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Paper>

            {/* Tabs Card */}
            <Paper
              elevation={1}
              sx={{
                // height: "calc(83vh - 110px)",
                height: summaryExpanded
                  ? "calc(70vh - 16px)" // 16px for gap between summary and tabs
                  : "calc(100vh - 140px - 50px - 16px)", // 50px summary + gap
                borderRadius: "8px",
                border: `1px solid ${theme.palette.mode === "dark" ? "#2D2D2D" : "#E5E7EB"
                  }`,
                flex: 1,
                display: "flex",
                flexDirection: "column",
                bgcolor: theme.palette.mode === "dark" ? "#1E1E1E" : "#FFFFFF",
                "& .MuiTabs-root": {
                  minHeight: "40px",
                },
                "& .MuiTab-root": {
                  minHeight: "40px",
                  padding: "8px 16px",
                },
                transition: "height 0.3s",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor:
                    theme.palette.mode === "dark" ? "#2D2D2D" : "divider",
                }}
              >
                {isSummaryLoading ? (
                  <Box sx={{ px: 2, py: 1, display: "flex", gap: 2 }}>
                    <Skeleton
                      variant="rectangular"
                      width={80}
                      height={32}
                      sx={{ borderRadius: 2 }}
                    />
                    <Skeleton
                      variant="rectangular"
                      width={80}
                      height={32}
                      sx={{ borderRadius: 2 }}
                    />
                  </Box>
                ) : (
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    sx={{
                      "& .MuiTab-root": {
                        color:
                          theme.palette.mode === "dark" ? "#FFFFFF" : "#3A2ADA",
                        fontWeight: 800,
                        fontSize: 14,
                        "&.Mui-selected": {
                          color:
                            theme.palette.mode === "dark"
                              ? "#FFFFFF"
                              : "#3A2ADA",
                        },
                      },
                      "& .MuiTabs-indicator": {
                        backgroundColor:
                          theme.palette.mode === "dark"
                            ? "#FFFFFF"
                            : "primary.main",
                      },
                    }}
                    TabIndicatorProps={{
                      style: {
                        backgroundColor:
                          theme.palette.mode === "dark" ? "#FFFFFF" : undefined,
                      },
                    }}
                  >
                    <Tab label="CVE" />
                    <Tab label="Assets" />
                  </Tabs>
                )}
              </Box>

              <Box sx={{ flex: 1 }}>
                <TabPanel value={tabValue} index={0}>
                  <AgGridTable
                    data={cveData}
                    columnDefs={columnDefs}
                    pagination={true}
                    showSearch={true}
                    // height="calc(50vh - 93px)"
                    height="97%"
                    gridOptions={{
                      getRowId: (params) => String(params.data?.cve_id ?? params.data?.vector_string ?? ''),
                    }}
                    onRowClick={handleCVEClick}
                    isLoading={isLoading}
                  />
                </TabPanel>

                <TabPanel value={tabValue} index={1}>
                  <AgGridTable
                    data={assetData}
                    columnDefs={assetColumnDefs}
                    pagination={true}
                    showSearch={true}
                    height="97%"
                    gridOptions={gridOptions}
                    onRowClick={handleAssetRowClick}
                    isLoading={isLoading}
                  />
                </TabPanel>
              </Box>
            </Paper>

            {/* Asset Details Drawer */}
            <AssetDetailsDrawer
              open={assetDrawerOpen}
              onClose={() => {
                setAssetDrawerOpen(false);
              }}
              assetData={selectedAsset}
              isCloud={false}
              isMenu={MenuKebabDrawer}
              onReport={handleAssetComplianceReport}
              isCve={true}
            />

            <Drawer
              anchor="right"
              open={reportDrawerOpen}
              onClose={() => setReportDrawerOpen(false)}
              PaperProps={{ sx: { width: 400, borderRadius: 2 } }}
            >
              <AssetComplianceReportDrawer
                onClose={() => setReportDrawerOpen(false)}
                assetData={selectedAsset}
              />
            </Drawer>

            {/* CVE Details Drawer */}
            {selectedCVE && (
              <CVEDetailsDrawer
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                cveData={{
                  cve_id: selectedCVE.cve_id,
                  severity: selectedCVE.severity,
                  cvss_score: parseFloat(selectedCVE.score),
                  affected_assets: selectedCVE.asset_count,
                  summaryData: selectedCVE.summaryData,
                  cisa_key: selectedCVE.cisas_kev,
                }}
                isLoading={isDrawerLoading}
                initialTabIndex={selectedDrawerTab}
              />
            )}

            {/* Popover Component */}
            <Popover
              open={isPopoverOpen}
              onClose={handlePopoverClose}
              anchorReference="anchorPosition"
              anchorPosition={
                popoverAnchor !== null
                  ? { top: popoverAnchor.mouseY, left: popoverAnchor.mouseX }
                  : undefined
              }
              PaperProps={{
                sx: {
                  mt: 1,
                  ml: 1,
                  maxWidth: 400,
                },
              }}
            >
              <Box sx={{ p: 2, minWidth: 340 }}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 700,
                    mb: 1,
                    color: "#6C6CA6",
                    letterSpacing: 1,
                  }}
                >
                  {popoverContent?.topic || "CVSS SEVERITY AND METRICS"}
                </Typography>
                <Box sx={{ borderBottom: "1px solid #E0E0E0", mb: 2 }} />
                {popoverContent?.metrics && (
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: 2,
                    }}
                  >
                    {popoverContent.metrics.map((metric: any, idx: number) => (
                      <Box key={idx} sx={{ mb: 1 }}>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "#6C6CA6",
                            fontWeight: 500,
                            fontSize: "13px",
                          }}
                        >
                          {metric.name}
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: 700,
                            color: "#23235B",
                            fontSize: "16px",
                          }}
                        >
                          {metric.value}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            </Popover>

            {/* CVE Report Download Dialog */}
            <Dialog
              open={isReportDialogOpen}
              onClose={handleDialogClose}
              sx={{
                "& .MuiDialog-paper": {
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  width: "360px",
                  height: "300px",
                  borderRadius: "4px",
                  transform: "translate(-50%, -50%)",
                  padding: "10px",
                  boxSizing: "border-box",
                  overflow: "hidden",
                },
              }}
            >
              <DialogTitle
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "16px",
                  color: theme.palette.mode === "dark" ? "#ffffff" : "#101828",
                }}
              >
                Download Org CVE Report?
              </DialogTitle>
              <DialogContent
                sx={{
                  textAlign: "center",
                  fontWeight: 400,
                  fontSize: "14px",
                  color: theme.palette.mode === "dark" ? "#b0b0b0" : "#667085",
                  overflow: "visible",
                  maxHeight: "none",
                }}
              >
                <Typography variant="body2" sx={{ mb: 2, color: theme.palette.mode === "dark" ? "#b0b0b0" : "#666666" }}>
                  This report offers a comprehensive summary of your CVE data
                </Typography>
                <Typography
                  variant="body2"
                  fontWeight={500}
                  align="center"
                  sx={{ mb: 2, fontWeight: "bold" }}
                >
                  Report Format
                </Typography>
                <RadioGroup
                  value={reportFormat}
                  onChange={(e) => setReportFormat(e.target.value)}
                  row
                  sx={{ justifyContent: "center" }}
                >
                  <FormControlLabel value="excel" control={<Radio />} label="Excel" />
                  <FormControlLabel
                    value="pdf"
                    control={<Radio disabled />}
                    label="Pdf"
                    disabled
                  />
                </RadioGroup>
              </DialogContent>
              <DialogActions
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "12px",
                  paddingBottom: "24px",
                }}
              >
                <Button onClick={handleDialogClose} variant="outlined" sx={{ width: 130 }}>
                  Cancel
                </Button>
                <Button
                  onClick={handleDownloadReport}
                  variant="contained"
                  disabled={downloading}
                  color="primary"
                  sx={{ width: 130 }}
                >
                  {downloading ? (<Box display="flex" alignItems="center" gap={1}>
                    <CircularProgress size={10} sx={{ color: 'white' }} />
                    <Typography sx={{ color: 'white', fontSize: '11px' }}>
                      Downloading...
                    </Typography>
                  </Box>
                  ) : ("Download")}

                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </>
      )}
    </>
  );
};

export default CVEScreen;
